import loginSaga from './login/loginSaga';

export default [
  loginSaga
];
